var React = require('react');

function IconMinusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.1429 2.99805H0.857143C0.629814 2.99805 0.411797 2.89269 0.251051 2.70515C0.090306 2.51762 0 2.26326 0 1.99805C0 1.73283 0.090306 1.47848 0.251051 1.29094C0.411797 1.1034 0.629814 0.998047 0.857143 0.998047H11.1429C11.3702 0.998047 11.5882 1.1034 11.7489 1.29094C11.9097 1.47848 12 1.73283 12 1.99805C12 2.26326 11.9097 2.51762 11.7489 2.70515C11.5882 2.89269 11.3702 2.99805 11.1429 2.99805Z","fill":"#262C3C"}));
}

IconMinusInline.defaultProps = {"width":"12","height":"3","viewBox":"0 0 12 3","fill":"none"};

module.exports = IconMinusInline;

IconMinusInline.default = IconMinusInline;
